/** Fires a GA4 event only when gtag is loaded; Consent Mode v2 (src/lib/consent.ts) governs storage. */
export function trackEvent(name: string, params: Record<string, string | number> = {}) {
  if (typeof window === "undefined") return;
  const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
  if (typeof g !== "function") return;
  try {
    g("event", name, params);
  } catch {
    /* analytics must never break the page */
  }
}
